import { StorageService } from './../../../../shared/services/storage/storage.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SacPurposeDialogComponent } from '../sac-purpose-dialog/sac-purpose-dialog.component';
import { FrCausesVernacular } from 'src/app/shared/models/fundraiser-causes';

@Component({
  selector: 'app-sac-purpose',
  templateUrl: './sac-purpose.component.html',
  styleUrls: ['./sac-purpose.component.scss']
})
export class SacPurposeComponent implements OnInit {

  public purpose: String;
  @Input() public frType;
  @Output() selectionChangeEvent = new EventEmitter();
  @Input() public currentLanguage;
  @Input() public formInfo;

  frCausesVernacular: any[] = FrCausesVernacular;

  constructor(
    public variablesService: VariablesService,
    public dialog: MatDialog,
    public storageService: StorageService
  ) { }

  ngOnInit() {
    this.purpose = this.frType;
  }

  valueChanged() { // You can give any function name
    this.selectionChangeEvent.emit(this.purpose);
  }

  openDialog() {

  }

}
